const announcementInstances = new Map();

function initializeAnnouncement(section) {
  announcementInstances.get(section)?.();

  const timerField = section.querySelector('#countdown-timer');
  if (!timerField) return;

  const initialEndTime = new Date(timerField.dataset.endTime).getTime();
  const countdownDuration = 4 * 24 * 60 * 60 * 1000;
  let interval;
  let swiperInstance;

  function updateTimerDisplay() {
    const now = Date.now();
    let countdownEndTime = initialEndTime;

    // Preserve the existing repeating four-day countdown.
    if (now >= countdownEndTime) {
      const completedCycles = Math.floor((now - countdownEndTime) / countdownDuration) + 1;
      countdownEndTime += completedCycles * countdownDuration;
    }

    const remainingTime = countdownEndTime - now;
    const values = {
      days: [Math.floor(remainingTime / 86400000), 'Day'],
      hours: [Math.floor((remainingTime / 3600000) % 24), 'Hrs'],
      minutes: [Math.floor((remainingTime / 60000) % 60), 'Min'],
      seconds: [Math.floor((remainingTime / 1000) % 60), 'Sec'],
    };

    Object.entries(values).forEach(([name, [value, label]]) => {
      section.querySelectorAll(`.timer .${name}`).forEach(element => {
        element.textContent = `${String(value).padStart(2, '0')}${label}`;
      });
    });
  }

  function updateMobileSlider() {
    const slider = section.querySelector('.annoucement_containerMobile');
    if (window.innerWidth <= 768 && slider && typeof window.Swiper === 'function') {
      if (!swiperInstance) {
        swiperInstance = new window.Swiper(slider, {
          direction: 'vertical',
          loop: true,
          autoplay: { delay: 5000 },
        });
      }
    } else if (swiperInstance) {
      swiperInstance.destroy(true, true);
      swiperInstance = null;
    }
  }

  if (timerField.classList.contains('startCountDown') && Number.isFinite(initialEndTime)) {
    updateTimerDisplay();
    interval = window.setInterval(updateTimerDisplay, 1000);
  }
  updateMobileSlider();
  window.addEventListener('resize', updateMobileSlider);

  announcementInstances.set(section, () => {
    window.clearInterval(interval);
    window.removeEventListener('resize', updateMobileSlider);
    swiperInstance?.destroy(true, true);
    announcementInstances.delete(section);
  });
}

function initializeAnnouncements() {
  document.querySelectorAll('#countdown-timer').forEach(timer => {
    const section = timer.closest('.shopify-section');
    if (section) initializeAnnouncement(section);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeAnnouncements, { once: true });
} else {
  initializeAnnouncements();
}

document.addEventListener('shopify:section:load', event => initializeAnnouncement(event.target));
document.addEventListener('shopify:section:unload', event => announcementInstances.get(event.target)?.());
